export default [
  {
    path: "inspectionReport",
    name: "inspection-report",
    component: () =>
      import("@/views/reports/inspectionReport/InspectionReport.vue"),
  },
  {
    path: "inspectionSintetic",
    name: "inspection-sintetic",
    component: () =>
      import("@/views/reports/inspectionReport/InspectionSintetic.vue"),
  },
  {
    path: "inspectionAnalitic",
    name: "inspection-analitic",
    component: () =>
      import("@/views/reports/inspectionReport/InspectionAnalitic.vue"),
  },
  {
    path: "sisbraipIndicators",
    name: "sisbraip-indicators",
    component: () =>
      import("@/views/reports/sisbraipIndicators/SisbraipIndicators.vue"),
  },
  {
    path: "totalizersReport",
    name: "totalizers-report",
    component: () =>
      import(
        "@/views/reports/totalizersReport/TotalizersReport.vue"
      ),
  },
];
